import type * as React from 'react';

function SvgStarFull(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
      <path
        d="M16.256 19.805a.556.556 0 00.115-.406l-.716-6.476 4.207-4.79a.563.563 0 00.113-.535.525.525 0 00-.39-.363L13.49 5.953 10.447.273C10.355.103 10.185 0 10 0s-.355.104-.447.272L6.51 5.953.415 7.235a.525.525 0 00-.39.363.558.558 0 00.113.534l4.207 4.791L3.63 19.4a.552.552 0 00.208.498c.15.114.347.135.515.054L10 17.231l5.648 2.72a.488.488 0 00.249.048c.14-.01.27-.08.36-.194z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgStarFull;
